export const classRoomType = [
  {
    label: 'Kindergarten',
    options: [
      { label: 'KG 1', value: 'KG 1' },
      { label: 'KG 2', value: 'KG 2' },
    ],
  },
  {
    label: 'Primary School',
    options: [
      { label: 'Primary 1', value: 'Primary 1' },
      { label: 'Primary 2', value: 'Primary 2' },
      { label: 'Primary 3', value: 'Primary 3' },
      { label: 'Primary 4', value: 'Primary 4' },
      { label: 'Primary 5', value: 'Primary 5' },
      { label: 'Primary 6', value: 'Primary 6' },
    ],
  },
  {
    label: 'Junior High School',
    options: [
      { label: 'JHS 1', value: 'JHS 1' },
      { label: 'JHS 2', value: 'JHS 2' },
    ],
  },
  {
    label: 'Senior High School ',
    options: [
      { label: 'SHS 1', value: 'SHS 1' },
      { label: 'SHS 2', value: 'SHS 2' },
      { label: 'SHS 3', value: 'SHS 3' },
    ],
  },
  {
    label: 'Vocational and Technical Education',
    options: [
      { label: 'Level 1', value: 'Level 1' },
      { label: 'Level 2', value: 'Level 2' },
      { label: 'Level 3', value: 'Level 3' },
      { label: 'Level 4', value: 'Level 4' },
    ],
  },
]

export const divisions = [
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
]

export const userType = [
  { label: 'Student', value: 'Student' },
  { label: 'fTeacher', value: 'fTeacher' },
  { label: 'parent', value: 'parent' },
  { label: 'publisher', value: 'publisher' },
]

export const bloodGroups = [
  { label: 'A+VE', value: 'A+VE' },
  { label: 'A-VE', value: 'A-VE' },
  { label: 'B+VE', value: 'B+VE' },
  { label: 'B-VE', value: 'B-VE' },
  { label: 'O+VE', value: 'O+VE' },
  { label: 'O-VE', value: 'O-VE' },
  { label: 'AB+VE', value: 'AB+VE' },
  { label: 'AB-VE', value: 'AB-VE' },
]

export const yearsOfExperience = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
  { label: '19', value: '19' },
  { label: '20', value: '20' },
  { label: '21', value: '21' },
  { label: '22', value: '22' },
  { label: '23', value: '23' },
  { label: '24', value: '24' },
  { label: '25', value: '25' },
  { label: '26', value: '26' },
  { label: '27', value: '27' },
  { label: '28', value: '28' },
  { label: '29', value: '29' },
  { label: '30', value: '30' },
  { label: '31', value: '31' },
  { label: '32', value: '32' },
  { label: '33', value: '33' },
  { label: '34', value: '34' },
  { label: '35', value: '35' },
  { label: '36', value: '36' },
  { label: '37', value: '37' },
  { label: '38', value: '38' },
  { label: '39', value: '39' },
  { label: '40', value: '40' },
  { label: '41', value: '41' },
  { label: '42', value: '42' },
  { label: '43', value: '43' },
  { label: '44', value: '44' },
  { label: '45', value: '45' },
  { label: '46', value: '46' },
  { label: '47', value: '47' },
  { label: '48', value: '48' },
  { label: '49', value: '49' },
  { label: '50', value: '50' },
]

export const certificateList = [
  { label: 'BA', value: 'BA' },
  { label: 'BEd', value: 'BEd' },
  { label: 'BSc', value: 'BSc' },
  { label: 'HND', value: 'HND' },
  { label: 'MA', value: 'MA' },
  { label: 'MEd', value: 'MEd' },
  { label: 'MPhil', value: 'MPhil' },
  { label: 'MSc', value: 'MSc' },
  { label: 'PGDE', value: 'PGDE' },
  { label: 'DBE', value: 'DBE' },
]

export const levels = [
  {
    label: 'KINDERGARTEN',
    value: 'KINDERGARTEN',
  },
  {
    label: 'LOWER PRIMARY',
    value: 'LOWER PRIMARY',
  },
  {
    label: 'UPPER PRIMARY',
    value: 'UPPER PRIMARY',
  },
  {
    label: 'JHS',
    value: 'JHS',
  },
  {
    label: 'SHS - Business',
    value: 'SHS - Business',
  },
  {
    label: 'SHS - General Arts',
    value: 'SHS - General Arts',
  },
  {
    label: 'SHS - General Science',
    value: 'SHS - General Science',
  },
  {
    label: 'SHS - Home Economics',
    value: 'SHS - Home Economics',
  },
  {
    label: 'SHS - Visual Arts',
    value: 'SHS - Visual Arts',
  },
  // {
  //   label: 'SHS - Virtual Arts',
  //   value: 'SHS - Virtual Arts',
  // },
  {
    label: 'SHS - Agricultural Science',
    value: 'SHS - Agricultural Science',
  },
  {
    label: 'TVET - Engineering',
    value: 'TVET - Engineering',
  },
  {
    label: 'TVET - Construction',
    value: 'TVET - Construction',
  },
  // {
  //   label: 'TVET - Construction	curriculum',
  //   value: 'TVET - Construction	curriculum',
  // },
  {
    label: 'TVET - Hospitality And Tourism',
    value: 'TVET - Hospitality And Tourism',
  },
]

export const languages = [
  { label: 'Dagbani', value: 'Dagbani' },
  { label: 'Dangme', value: 'Dangme' },
  { label: 'English', value: 'English' },
  { label: 'Ewe', value: 'Ewe' },
  { label: 'French', value: 'French' },
  { label: 'Ga', value: 'Ga' },
  { label: 'Hausa', value: 'Hausa' },
  { label: 'Twi', value: 'Twi' },
]

export const signatureStyleNames = [
  'Autography',
  'Betterlett',
  'Darlington',
  'Creattion',
  'HealingFairy',
  'KimberlySignature',
  'Pontgraph',
  'Reinatha',
]

export const subjectsMaster = [
  { value: 'Animal Husbandry', label: 'Animal Husbandry' },
  { value: 'Auto Mechanic', label: 'Auto Mechanic' },
  {
    value: 'Basic Design And Technology',
    label: 'Basic Design And Technology',
  },
  { value: 'Biology', label: 'Biology' },
  { value: 'Building And Construction', label: 'Building And Construction' },
  { value: 'Business Management', label: 'Business Management' },
  { value: 'Ceramics', label: 'Ceramics' },
  { value: 'Chemistry', label: 'Chemistry' },
  {
    value: 'Christian Religious Studies',
    label: 'Christian Religious Studies',
  },
  { value: 'Clothing And Textiles', label: 'Clothing And Textiles' },
  { value: 'Core Mathematics', label: 'Core Mathematics' },
  { value: 'Cost Accounting', label: 'Cost Accounting' },
  { value: 'Creative Arts', label: 'Creative Arts' },
  { value: 'Economics', label: 'Economics' },
  {
    value: 'Elective Information Communication Technology',
    label: 'Elective Information Communication Technology',
  },
  { value: 'Elective Mathematics', label: 'Elective Mathematics' },
  { value: 'Electricals', label: 'Electricals' },
  { value: 'English Language', label: 'English Language' },
  { value: 'Financial Accounting', label: 'Financial Accounting' },
  { value: 'Food And Nutrition', label: 'Food And Nutrition' },
  { value: 'French', label: 'French' },
  { value: 'General Agriculture', label: 'General Agriculture' },
  { value: 'General Knowledge In Arts', label: 'General Knowledge In Arts' },
  { value: 'Geography', label: 'Geography' },
  { value: 'Ghanaian Language', label: 'Ghanaian Language' },
  { value: 'Government', label: 'Government' },
  { value: 'Graphic Designs', label: 'Graphic Designs' },
  { value: 'History', label: 'History' },
  {
    value: 'Information Communication And Technology',
    label: 'Information Communication And Technology',
  },
  { value: 'Integrated Science', label: 'Integrated Science' },
  { value: 'Languages', label: 'Languages' },
  { value: 'Literature', label: 'Literature' },
  { value: 'Management In Living', label: 'Management In Living' },
  { value: 'Metal Works', label: 'Metal Works' },
  { value: 'Our World Our People', label: 'Our World Our People' },
  { value: 'Physical Education', label: 'Physical Education' },
  { value: 'Physics', label: 'Physics' },
  {
    value: 'Religious And Moral Education',
    label: 'Religious And Moral Education',
  },
  { value: 'Social Studies', label: 'Social Studies' },
  { value: 'Technical Drawing', label: 'Technical Drawing' },
  { value: 'Textiles', label: 'Textiles' },
  { value: 'Wood Work', label: 'Wood Work' },
]

// export const subjectsMaster = [
//   { value: 'English', label: 'English' },
//   { value: 'Science', label: 'Science' },
//   { value: 'History', label: 'History' },
//   { value: 'Drawing', label: 'Drawing' },
//   { value: 'Mathematics', label: 'Mathematics' },
//   { value: 'Agriculture', label: 'Agriculture' },
//   { value: 'Asante Twi', label: 'Asante Twi' },
//   { value: 'Creative Arts', label: 'Creative Arts' },
//   { value: 'Social Science', label: 'Social Science' },
//   { value: 'Robotics Science', label: 'Robotics Science' },
//   { value: 'Kids Subject 1', label: 'Kids Subject 1' },
//   { value: 'Social Studies', label: 'Social Studies' },
//   { value: 'Robotics Science', label: 'Robotics Science' },
//   { value: 'History Of Ghana', label: 'History Of Ghana' },
//   { value: 'Ghanaian Language', label: 'Ghanaian Language' },
//   { value: 'Integrated Science', label: 'Integrated Science' },
//   { value: 'Physical Education', label: 'Physical Education' },
//   { value: 'Our World Our People', label: 'Our World Our People' },
//   { value: 'Computer Programming', label: 'Computer Programming' },
//   { value: 'Science And Technology', label: 'Science And Technology' },
//   { value: "Basic 1. Teacher's Guide", label: "Basic 1. Teacher's Guide" },
//   { value: "Basic 2. Teacher's Guide", label: "Basic 2. Teacher's Guide" },
//   { value: "Basic 3. Teacher's Guide", label: "Basic 3. Teacher's Guide" },
//   { value: "Basic 4. Teacher's Guide", label: "Basic 4. Teacher's Guide" },
//   { value: "Basic 5. Teacher's Guide", label: "Basic 5. Teacher's Guide" },
//   { value: "Basic 6. Teacher's Guide", label: "Basic 6. Teacher's Guide" },
//   { value: 'Practical English Language', label: 'Practical English Language' },
//   {
//     value: 'Religious And Moral Education',
//     label: 'Religious And Moral Education',
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 1",
//     label: "Asante Twi - Teacher's Guide 1",
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 2",
//     label: "Asante Twi - Teacher's Guide 2",
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 3",
//     label: "Asante Twi - Teacher's Guide 3",
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 4",
//     label: "Asante Twi - Teacher's Guide 4",
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 5",
//     label: "Asante Twi - Teacher's Guide 5",
//   },
//   {
//     value: "Asante Twi - Teacher's Guide 6",
//     label: "Asante Twi - Teacher's Guide 6",
//   },
// ]
